import { render, staticRenderFns } from "./T1Paginacja.vue?vue&type=template&id=357468fd&scoped=true&"
import script from "./T1Paginacja.vue?vue&type=script&lang=js&"
export * from "./T1Paginacja.vue?vue&type=script&lang=js&"
import style0 from "./T1Paginacja.vue?vue&type=style&index=0&id=357468fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357468fd",
  null
  
)

export default component.exports